const TOKEN_KEY = "token";
const LEGACY_TOKEN_KEY = "mellbizz_token";
const EXP_KEY = "token_expiry";

function parseJwt(token) {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

export function setToken(token) {
  if (!token) return;
  localStorage.setItem(TOKEN_KEY, token);

  // Always derive expiry from JWT `exp` claim (source of truth)
  const payload = parseJwt(token);
  if (payload && payload.exp) {
    // exp is in seconds, convert to ms
    localStorage.setItem(EXP_KEY, String(payload.exp * 1000));
  }
}

export function getToken() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) return token;
  const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
  if (legacy) {
    setToken(legacy);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    return legacy;
  }
  return null;
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXP_KEY);
}

export function isTokenExpired(token) {
  const t = token || getToken();
  if (!t) return true;

  const payload = parseJwt(t);
  if (payload && payload.exp) {
    return Date.now() > payload.exp * 1000;
  }

  const expStr = localStorage.getItem(EXP_KEY);
  if (expStr) {
    const exp = parseInt(expStr, 10);
    if (!isNaN(exp)) return Date.now() > exp;
  }

  // If we cannot determine expiry, consider token valid (server must enforce expiry)
  return false;
}

export function isAuthenticated() {
  const token = getToken();
  if (!token) return false;
  return !isTokenExpired(token);
}

const authUtils = {
  setToken,
  getToken,
  removeToken,
  isTokenExpired,
  isAuthenticated,
};

export default authUtils;
